import { AnyAction } from 'redux'
import { createSelector } from 'reselect'
import type { State } from 'shared/types/gallery/state'

const initialState: State.FilterByOptionState = {}

export function reducer(state: State.FilterByOptionState = initialState, action: AnyAction): State.FilterByOptionState {
  switch (action.type) {
    default:
      return state
  }
}

export const optionNameByFilterNameSelector = createSelector(
  (state: State.GlobalState) => state.optionNameByFilterName,
  (optionNameByFilterName) => (optionName: string) => optionNameByFilterName[optionName],
)
